import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://groups-service.demo.onyxcentersource.com',
  hostname: 'groups.demo.onyxcentersource.com',
  portalUrl: 'https://portal.demo.onyxcentersource.com',
  onyxCommonDataUrl: 'https://ocd-service.demo.onyxcentersource.com/api',
  onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
  invoiceHistoryUrl: 'https://ooiv-invoice-history.demo.onyxcentersource.com',
  emailValidation: true,
  cwr: {
    enable: true
  },
  agencyDashboardUrl: 'https://agency-dashboard.demo.onyxcentersource.com',
  showAgencyDashboard: false
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.demo.ts